module.exports = __webpack_public_path__ + "img/pay-welfare-banner.d06ad35e.png";